export default "__VITE_ASSET__AvKqUGrK__"